import { put, takeEvery, call, all } from "redux-saga/effects";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import endpoints from "../endpoints";

function* commonFunction(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "auth-token": endpoints.token,
        username: fmsUser.username,
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      yield toast.success(value.toastMsg, {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* commonFunction2(value) {
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      yield toast.success(value.toastMsg, {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* fetchResidentsData() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  try {
    let params = {
      api:
        `${appConfig.urlPrefixIp}${endpoints.getResidets}` + fmsUser.society_id,
      method: "GET",
      sucessAction: actionTypes.FETCH_RESIDENTSDATA_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_RESIDENTSDATA_FAIL_ACTION,
      body: null,
    };
    const Res = yield call(commonFunction, params);
    return Res;
  } catch (e) {}
}

function* updateResidentData(value) {
  const [ownerRes, residentRes] = yield all([
    call(updateOwner, value.value),
    call(updateResident, value.value),
  ]);
  if (ownerRes.status === true && residentRes.status === true) {
    yield put({
      type: actionTypes.UPDATE_RESIDENTSDATA_SUCCESS_ACTION,
    });
    yield toast.success("Successfully updated", {
      autoClose: 3000,
    });
  } else {
    yield toast.error("Failed to update", {
      autoClose: 3000,
    });
  }
}

function* updateOwner(data) {
  let apyId = data.apid;
  const ownerData = {
    ownerName: data.ownerName.trim(),
    ownerPhone: data.ownerIsd.trim() + "-" + data.ownerNo.trim(),
    ownerEmail: data.ownerEmail.trim(),
  };
  const ownerBody = new FormData();
  ownerBody.append("payload", JSON.stringify(ownerData));
  try {
    let params = {
      api: `${appConfig.urlPhpPrefixIp}${endpoints.updateOwner}${apyId}`,
      method: "POST",
      sucessAction: null,
      failAction: null,
      body: ownerBody,
    };
    const Res = yield call(commonFunction2, params);
    return Res;
  } catch (e) {}
}

function* updateResident(data) {
  let apyId = data.apid;
  const residentData = {
    residentName: data.residentName.trim(),
    residentPhone: data.residentIsd.trim() + "-" + data.residentNo.trim(),
    residentEmail: data.residentEmail.trim(),
    phoneChanged: false,
  };
  const residentBody = new FormData();
  residentBody.append("payload", JSON.stringify(residentData));
  try {
    let params = {
      api: `${appConfig.urlPhpPrefixIp}${endpoints.updateResident}${apyId}`,
      method: "POST",
      sucessAction: null,
      failAction: null,
      body: residentBody,
    };
    const Res = yield call(commonFunction2, params);
    return Res;
  } catch (e) {}
}

export function* residentsActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_RESIDENTSDATA_INIT_ACTION,
    fetchResidentsData
  );
  yield takeEvery(
    actionTypes.UPDATE_RESIDENTSDATA_INIT_ACTION,
    updateResidentData
  );
}
